export type QuoteStatus = 'Kladde' | 'Sendt' | 'Accepteret' | 'Afvist' | 'Udløbet'

export const quoteStatuses: QuoteStatus[] = ['Kladde', 'Sendt', 'Accepteret', 'Afvist', 'Udløbet']

export type QuoteUnit = 'stk.' | 'timer' | 'meter' | 'fast pris'

export const quoteUnits: QuoteUnit[] = ['stk.', 'timer', 'meter', 'fast pris']

export interface QuoteLine {
  id: string
  description: string
  quantity: number
  unit: QuoteUnit
  unitPrice: number
  /** Momssats i procent, fx 25. */
  vatRate: number
}

/** Én hændelse i tilbuddets historik, fx "Tilbud sendt til kunde". */
export interface QuoteEvent {
  id: string
  text: string
  at: string
  by?: string
}

export interface Quote {
  id: string
  quoteNumber: string

  customerId: string
  customerName: string
  customerEmail: string
  customerPhone: string
  customerAddress: string

  /** Henvendelsen tilbuddet er lavet ud fra. */
  enquiryId?: string
  /** Sagen der er oprettet fra tilbuddet. */
  caseId?: string

  title: string
  description: string
  lines: QuoteLine[]

  subtotal: number
  vatAmount: number
  total: number

  status: QuoteStatus
  quoteDate: string
  validUntil: string

  internalNotes: string
  customerNotes: string

  createdAt: string
  updatedAt: string
  sentAt?: string
  acceptedAt?: string
  rejectedAt?: string

  /**
   * Mailudsendelse sker gennem en sikker backend (Firebase Functions →
   * Microsoft 365 / Graph). Frontend indeholder ingen mail-credentials.
   */
  emailStatus?: 'ikke sendt' | 'sendt' | 'fejlet'
  emailSentAt?: string
  /** Modtagerens e-mail ved seneste udsendelse. */
  sentTo?: string
  /** Administratoren der sendte tilbuddet. */
  sentBy?: string
  /** Tidspunkt for seneste udsendelse — opdateres ved hver ny afsendelse. */
  lastSentAt?: string
  /** Aktivitetslog: oprettet, gemt, sendt … */
  history?: QuoteEvent[]
  /** Forberedt til senere fakturering i Dinero. */
  dineroInvoiceId?: string
}

export interface QuoteInput {
  customerId: string
  newCustomer?: { name: string; phone: string; email: string; address: string }
  enquiryId?: string
  title: string
  description: string
  lines: QuoteLine[]
  quoteDate: string
  validUntil: string
  internalNotes: string
  customerNotes: string
  status: QuoteStatus
}

export interface QuoteTotals {
  subtotal: number
  vatAmount: number
  total: number
}
